<template>
    <div v-if="allLoaded">
        <div class="pt-2 pb-3 px-3 container-story" :class="{'focus-story' : !elemBodySlim}">                    
            <b-row align-v="center" class="px-3 border-bottom pb-1 component-to-toggle" @click="expand">
                <b-col cols="10" class="p-0">
                    <h4 class="m-0" :ref="'simple-story' + elemId">{{ elemTitle.split('__')[0] }}</h4>
                </b-col>
                <b-col class="px-0 text-center">
                    <i class="now-ui-icons arrows-1_minimal-up arrowRightIcon iconToggle" 
                        :class="{'i-rotate' : !elemBodySlim}" style=""></i>
                </b-col>
            </b-row>  
            <b-row class="px-3">
                <p v-if="onDesktopInner | !elemBodySlim" v-html="elemBody" class="mb-2 pt-3"></p>
                <a class="p-0 a-med" @click="expand">{{$t(titleDiscover)}}</a>
                <p style="font-weight:400" class="ml-2">{{ elemTitle.split('__')[1] }}</p>
            </b-row>
            
            <b-row v-if="carousel && elemImgs" class="d-flex justify-content-center">            
                <b-carousel id="carousel-1"
                v-model="slide"
                :interval="0"
                :controls="showCarouselControl"
                indicators 
                no-wrap                      
                background="lightgray"                    
                style="height: 300px;"
                @sliding-start="onSlideStart"
                @sliding-end="onSlideEnd">

                <b-carousel-slide v-for="(img, id) in elemImgs" :key="id" style="height: 300px;" 
                
                    :text-html="'<b><span style=\'font-size:0.9em;\'>' + img['o:title'] + '</span></b>'">                    
                    <img slot="img" class="d-block img-fluid carouselImage"
                                style="height:300px; object-fit: contain;"                                
                                :src="img['o:original_url']"                            
                            >
                </b-carousel-slide>                
             </b-carousel>
            </b-row>
            <!-- <b-row>
                <Media
                    :media="elemImgs"
                    :handleText="false"                    
                />
            </b-row> -->
        </div>  
    </div>
</template>

<script>
const Common = require('@/Common.vue').default
import {Button} from '@/components'

import {
  hyphenateSync
} from "hyphen/it";

export default {
    components: { [Button.name]: Button },
    name: 'SimpleSubStory',

    props: {
      elem : {
          type: Object,
          required: true
      },
      elemId : {
        type: Number,
        required: true
      },
      handler: {
        type: Function, 
        required: true
      }    
    },

    data() {
      return {
            windowWidth : window.innerWidth,
            elemTitle : undefined,
            elemBody : undefined,
            elemBodySlim : true,     
            carousel : false,
            elemImgs : undefined,
            slide : 0     
      }
    },

    mounted() {
        this.elemTitle = this.md(this.cardTitleSottostorie(this.elem))
        this.elemBody = this.md(this.cardBodySottostorie(this.elem, 250))
        this.elemImgs = this.elem['mediaList'].length > 0 ? 
            this.elem['mediaList'].filter(i => i['o:media_type'] && i['o:media_type'].includes('image')) : undefined;
        window.addEventListener('resize', this.handleResize);
    },

    methods: {

        
        // Start Carousel 
        onSlideStart() {            
        },
        onSlideEnd() {
            if(!this.showCarouselControl)
                return;
            switch (this.slide) {
                case 0:
                    this.controlButtons('carousel-control-prev', 'hidden')
                    this.controlButtons('carousel-control-next', 'visible')  
                    break;
                case this.elemImgs.length -1:
                    this.controlButtons('carousel-control-prev', 'visible')
                    this.controlButtons('carousel-control-next', 'hidden')
                    break
                default:
                    this.controlButtons('carousel-control-prev', 'visible')                    
                    this.controlButtons('carousel-control-next', 'visible')                    
                    break;
            }            
        },
        // End Carousel 
        controlButtons(css_class, value) {    
            // carousel-control-next-icon
            let x = document.getElementsByClassName(css_class);
            if(x.length <= 0){
                return
            }    
            for(let i = 0; i < x.length; i++)
                x[i].style.visibility = value; 
        },
        handleResize() {
            this.windowWidth = window.innerWidth;
        },
        md(st) {
            return hyphenateSync(Common.removeMarkdown(st))
        },
        // Wrapper for Common.safeString
        s(unsafeString,chain,debugging_label = null){
            return Common.safeString(unsafeString,chain,debugging_label)
        },

        translate: function(key, suffix=this.$store.getters.getLanguage) {
                return this.$store.getters.getMappingLanguage[key + suffix]
        },

        cardTitleSottostorie: function(elem){
            let s = this.s(elem,[this.translate("tri:Titolo_"),0,"@value"])
            return s ? s : this.s(elem,[this.translate("tri:Titolo_", 'it'),0,"@value"])
        },

        cardBodySottostorie: function(elem, len) {            
            let s = this.s(elem,[this.translate("dcterms:description_"),0,"@value"])
            s = s ? s : this.s(elem,[this.translate("dcterms:description_", 'it'),0,"@value"])     

            return s.substr(0, len) + (this.s(elem,["dcterms:description",0,"@value"]).length > len ? '...' : '')
            // if(this.s(elem,["dcterms:description",0,"@value"]) !== "")
            //     return this.s(elem,["dcterms:description",0,"@value"]).substr(0,len) + (this.s(elem,["dcterms:description",0,"@value"]).length > len ? '...' : '')
            // else
            //     return this.s(elem,["dcterms:description",0,"@value"]).substr(0,len) + (this.s(elem,["dcterms:description",0,"@value"]).length > len ? '...' : '')
        },

        expand() {    
            let self = this
            self.handler(this.elemId)
        
            
            if(this.elemBodySlim) {
                let extra_log_info = 'tri:sottostoria[' + this.elem['o:id'] + ']'
                Common.addLog(this,this.$route.path, extra_log_info, res => {});                                
                let self = this;
            
                this.carousel = true;
                setTimeout(() => {
                    self.controlButtons('carousel-control-prev', 'hidden');
                }, 200); 
        

                this.elemBody = Common.processMarkdown(this.cardBodySottostorie(this.elem, undefined))
                this.elemBodySlim = false
                setTimeout(() => {
                    let y = self.$refs['simple-story' + self.elemId].getBoundingClientRect().top + window.scrollY - 150                
                    window.scrollTo({ top: y, behavior: 'smooth' });                
                }, 150)
            }
            else{    
                this.carousel = false;
                this.slide = 0;
                let y = self.$refs['simple-story' + self.elemId].getBoundingClientRect().top + window.scrollY - 150                
                window.scrollTo({ top: y, behavior: 'smooth' });
                setTimeout(() => {
                    self.elemBody = self.md(this.cardBodySottostorie(self.elem, 250))
                    self.elemBodySlim = true                
                }, 150)                      
            }
        },
        reduce() {
            this.elemBody = this.md(this.cardBodySottostorie(this.elem, 250))
            this.elemBodySlim = true;    
            this.carousel = false;    
            this.slide = 0;
        },
    },

    computed : {
        onDesktopInner() {
            return this.windowWidth >= 768
        },
        allLoaded() {
            return this.elemTitle && this.elemBody
        },
        titleDiscover() {
            return this.elemBodySlim ? 'scopri' : 'riduci'
        },
        showCarouselControl() {
            return this.elemImgs && this.elemImgs.length > 1;
        }
    }
}
</script>

<style scoped lang="scss">
@import "~bootstrap/scss/functions";
@import "~bootstrap/scss/variables";
@import "~bootstrap/scss/mixins";


.carousel-caption{
    right: 0% !important;
    left: 0% !important;
    bottom: 0% !important;
    background:fixed !important;
    padding-bottom:5px !important;
}

.container-story {
    box-shadow: 0px 4px 8px rgba(0, 0, 0, 0.33);
    background-color: rgba(245, 245, 245, 0.25);
}
.a-med {
    font-size: medium;
}
.focus-story {
    background-color: #fba7473d;
    box-shadow: 0px 4px 8px rgba(0, 0, 0, 0.675);
}
.component-to-toggle {
    cursor: pointer;
}
.border-bottom {
    border-color: rgba(172, 172, 172, 0.74) !important;
}
.iconToggle {
    font-size:2em; 
    font-weight: bolder;
    transition-duration: .2s;
    transform: rotate(90deg)
}
.i-rotate {
    transform: rotate(180deg)
}
</style>
